// extracted by mini-css-extract-plugin
export const text = "text-module--text--CkJ0Z";
export const sm = "text-module--sm--SwnqU";
export const md = "text-module--md--Hln4f";
export const lg = "text-module--lg--YQFCS";